(() => {
  function setup(root) {
    if (root.dataset.ycbReady) return;
    root.dataset.ycbReady = 'true';
    const form = root.querySelector('form');
    const duration = form.elements.duration;
    const output = root.querySelector('[data-ycb-duration]');
    const adjusters = root.querySelectorAll('[data-ycb-adjust]');
    function updateDuration(next) {
      const value = Math.min(60, Math.max(5, next));
      duration.value = String(value);
      output.textContent = String(value);
      const ring = root.querySelector('[data-ycb-ring]');
      const handle = root.querySelector('[data-ycb-ring-handle]');
      if (ring) ring.setAttribute('stroke-dasharray', `${value / 60 * 100} 100`);
      if (handle) handle.setAttribute('transform', `rotate(${value / 60 * 360} 104 104)`);
      adjusters.forEach(button => {
        button.disabled = Number(button.dataset.ycbAdjust) < 0 ? value === 5 : value === 60;
      });
    }
    adjusters.forEach(button => {
      button.addEventListener('click', () => {
        updateDuration(Number(duration.value) + Number(button.dataset.ycbAdjust));
      });
    });
    updateDuration(Number(duration.value));
    root.querySelectorAll('[data-ycb-audience]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-ycb-audience]').forEach(item => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        root.querySelector('[data-ycb-teacher-label]').textContent =
          button.dataset.ycbAudience === 'teacher' ? 'Choose your class guide' : 'Choose your teacher';
      });
    });
    form.addEventListener('submit', event => event.preventDefault());
  }
  document.querySelectorAll('[data-ys-class-builder]').forEach(setup);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-ys-class-builder]').forEach(setup);
  });
})();
